<template>
  <div class="yk-qw-content yk-qw-content-new-course">
    <div class="yk-come-back-btn-wrapper">
      <!-- <el-button size="small"
                 type="primary"
                 @click="backtoclass"
                 class="yk-btn-new yk-btn-new-back-s"
                 icon="wl-icon-fanhui2"></el-button> -->
      <!-- <el-button size="small"
                 type="primary"
                 @click="ImportQueDialogVisible=true"
      class="yk-course-item-bank">学校资源库导入</el-button>-->
    </div>
    <div class="clearfix tea-quesiton-ware-content">
      <div style="width:260px;height:100%;"
           class="tea-question-side-wrapper tea-question-set-knowledge-con">
        <div class="yk-el-aside">
          <div class="yk-el-aside-title">
            <i class="wl-icon-zhishidian"></i>&nbsp;知识点
          </div>
          <div class="yk-max-height-left">
            <div class="yk-qu-con"
                 :class="{active: active == courseId}"
                 @click="onAllQuesionChangeHandler(courseId)">
              <i class="wl-icon-xiaoyuan"></i>
              <div class="yk-title">全部</div>
              <span style="margin-left: 16px;color:#FFF;background:#409EFF;">{{totalCount}}</span>
              <p class="line-active"></p>
            </div>
            <div class="yk-qu-con"
                 v-for="(item,index) in knowledgeLists"
                 :key="item.Id"
                 @click="onKnowledgeChangeHandler(item.Id,item.KnowledgeName)"
                 :class="{active: active == item.Id}">
              <p class="point-span"
                 :title="index"></p>
              <div class="yk-title"
                   :title="item.KnowledgeName">{{item.KnowledgeName}}</div>
              <span>{{item.questionCount}}</span>
              <p class="line-active"></p>
            </div>
            <div class="yk-qu-con-footer"
                 :class="{active: active == 'NotSet'}"
                 @click="onAllQuesionChangeHandler(courseId,'NotSet')">
              <i class="wl-icon-xiaoyuan"></i>
              <div class="yk-title">未设置知识点</div>
              <span>{{notsetCount}}</span>
              <p class="line-active"></p>
            </div>
          </div>
          <div class="yk-add-group"
               @click="addGroup">
            <div v-if="addShow">
              <i class="el-icon-circle-plus-outline"></i>
              <span style="color:#409EFF;margin-left:7px">添加知识点</span>
            </div>
            <el-input v-if="inShow"
                      v-model="knowledge"
                      placeholder="输入名称，按Enter确认"
                      @keyup.enter.native="newKnowledge"
                      @blur="addNewKnowledge"
                      class="confirm"
                      ref="newKnowledgeInput"></el-input>
          </div>
        </div>
      </div>
      <div class="tea-question-main-wrapper">
        <div class="yk-main-head">
          <div class="yk-que-name">
            <div v-if="showTestName && queMainName"
                 class="yk-update-que-name-wrapper clearfix">
              <div class="que-main-name">{{queMainName}}</div>
              <div class="yk-update-que-name-operate">
                <el-dropdown size="mini"
                             placement="bottom-start">
                  <i class="el-icon-edit"
                     @click="updateKnowledge"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>重命名</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown size="mini"
                             placement="bottom-start">
                  <i class="el-icon-delete"
                     @click="deleteKnowledge"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <el-input v-model="knowledgeNew"
                      placeholder="请输入新的名称Enter确认"
                      v-if="inTestName"
                      style="width:200px;"
                      @keyup.enter.native="enterUpdateName"
                      @blur="hideInput"
                      autofocus="autofocus"></el-input>
          </div>
          <!-- <el-button class="export"
                     type="primary"
                     @click="exportTips">导出Excel</el-button> -->
          <div class="yk-que-config">
            <el-form ref="form"
                     :inline="true">
              <!--   <el-form-item label="题目">
                                <el-select placeholder="请输入" v-model="checkContent" clearable @change="getQuestionList(1)">
                                    <el-option  :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                <el-select>
              </el-form-item>-->
              <el-form-item label="题目："
                            class="el-form-item-search-que-name el-form-change-search">
                <el-input style="width:auto"
                          placeholder="请输入题目名称"
                          v-model="checkContent">
                  <!-- <el-button slot="append" icon="el-icon-search" @click="search()"></el-button> -->
                  <i slot="suffix"
                     class="el-input__icon el-icon-search"
                     @click="search()"></i>
                </el-input>
              </el-form-item>

              <el-form-item label="题型："
                            class="el-form-item-que-type el-form-change-search">
                <el-select placeholder="请选择题型"
                           v-model="checkType"
                           clearable
                           @change="getQuestionList(1)">
                  <el-option v-for="item in form.queType"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="难度："
                            class="el-form-item-que-type el-form-change-search"
                            style="margin-right:0">
                <el-select v-model="checkDiffcult"
                           placeholder="请选择难度"
                           width="100px"
                           clearable
                           @change="getQuestionList(1)">
                  <el-option v-for="item in form.diffType"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 题目栏 -->
        <div class="add-question-new-wrapper-s clearfix">
          <div @click="addQuestion"
               class="add-question-new-wrapper-child-1">
            <i class="el-icon-circle-plus-outline"></i>
            <span style="color:#409EFF">添加题目</span>
          </div>
          <div @click="ImportDialogVisible=true"
               class="add-question-new-wrapper-child-2">
            <i class="wl-icon-exceldaoru"></i>
            <span style="color:#409EFF">Excel导入</span>
          </div>
          <div @click="exportTips"
               class="add-question-new-wrapper-child-2">
            <i class="wl-icon-daoru1"
               style="font-size:17px;margin-right:0;vertical-align:0;"></i>
            <span style="color:#409EFF">导出Excel</span>
          </div>
        </div>
        <div class="yk-main-que-content">
          <div class="yk-que-con"
               v-for="(item,index) in questionLists"
               :key="item.questionId">
            <div class="yk-que-head">
              <div class="yk-que-head-info">
                <span class="que-index">{{(pageIndex-1)*pageSize + index + 1}}</span>
                <span class="que-type">{{item.questionType}}</span>
                <span style="font-size: 18px; margin-left: 25px;">难度：</span>
                <span class="diff-type">{{item.difficulty}}</span>
              </div>
              <!-- <div class="yk-que-head-operate">
                  <el-button type="primary"
                            size="mini"
                            @click="setQuestionInfo(item)"
                            icon='wl-icon-chakan'
                            >详情</el-button>
                  <el-button size='mini'
                  @click.native="queEditor(item.questionId,item.questionType)"
                  icon='el-icon-edit-outline' style='margin-left:0'>编辑</el-button>
                  <el-button size='mini'
                  @click.native="queDeleteList(item.questionId)"
                  icon='el-icon-delete' class='delete' style='margin-left:10px'>删除</el-button>
              </div>-->
              <div class="yk-que-head-operate"
                   @click="queDeleteList(item.questionId)">
                <i class="el-icon-delete"></i>
                <span>删除</span>
              </div>
              <div class="yk-que-head-operate"
                   @click="setQuestionInfo(item)">
                <i class="wl-icon-chakan"></i>
                <span>详情</span>
              </div>
              <div class="yk-que-head-operate"
                   @click="queEditor(item.questionId,item.questionType)">
                <i class="el-icon-edit-outline"></i>
                <span>编辑</span>
              </div>
            </div>
            <!-- <span class='title'>题目:</span> -->
            <div class="yk-que-name clearfix">
              <span class="left">题目:</span>
              <span class="left que-li"
                    v-html="item.content"></span>
            </div>
            <div class="yk-que-opotion"
                 v-if="item.questionType == '1' || item.questionType == '2'">
              <ul>
                <li v-for="(value,key) in item.selectContent"
                    :key="key">
                  <span v-if="value">{{selects[key]}}</span>
                  <span>{{value}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="noDataShow"
               class="yk-nodata-source-content">
            <img src="~assets/images/the-last-new-nodata-imag.png"
                 alt
                 class="yk-prompt">
            <div class="sp-noData">暂无题目，请添加题目或Excel导入。</div>
          </div>
        </div>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="onPageChangeHandler"
                       :current-page="pageIndex"
                       :page-sizes="[10,50,100,200,500,1000]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"
                       v-show="total>0"></el-pagination>
      </div>
    </div>

    <!-- 添加题目类型组件 -->
    <!-- <div class="yk-dialogCon-new-s"
          v-show="showChoice">
        <div class="yk-choiceCon">
          <div class="yk-add-group">
            <span class="knowledge">知识点</span>
            <el-select v-model="valueEditor"
                      placeholder="请选择"
                      @change="addQueToKnowList">
              <el-option v-for="item in knowledgeLists"
                        :key="item.Id"
                        :label="item.KnowledgeName"
                        :value="item.Id">
              </el-option>
            </el-select>
            <i class="el-icon-close"
              @click="closeEditorDialog"></i>

          </div>
          <Choice v-if="showChoice"
                  ref="Choice"
                  :data.sync="editorQueData"
                  :valueEditor='valueEditor'
                  :childQuestionList='childQuestionList'
                  :showChoice='showChoice'
                  :knowledge='knowledgeId'
                  :checkDiffcult='checkDiffcult'
                  :courseId='courseId'
                  :stemFiles='stemFiles'
                  :analysisFile='analysisFile'
                  @newNodeEvent="savaQuestionInfo"
                  @closeDialog="parentCloseListen"
                  @done='refresh'></Choice>
        </div>
    </div>-->
    <!-- 删除考试确认对话框 -->
    <el-dialog title="提示"
               :visible.sync="centerDialogVisible"
               width="30%"
               center
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <div style="text-align:center;color:red;font-size:20px;">确认删除</div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="sureDeleteTest">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 题目详情 -->
    <el-dialog :title="questionInfo.QuestionType +'——' + questionInfo.Difficulty"
               :visible.sync="queDetailDialogVisible"
               width="70%"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               v-if="queDetailDialogVisible">
      <Multiselect :IsTitle="false"
                   :IsSelects="-1"
                   :IsAnswers="true"
                   :IsAnalysis="-1"
                   v-if="questionInfo.QuestionType === '单选题' || questionInfo.QuestionType == '多选题'"
                   :data="questionInfo" />
      <true-false :IsTitle="false"
                  :IsSelects="-1"
                  :IsAnswers="true"
                  :IsAnalysis="-1"
                  v-else-if="questionInfo.QuestionType =='判断题'"
                  :data="questionInfo" />
      <fillInTheBlanks :IsTitle="false"
                       :IsSelects="-1"
                       :IsAnswers="true"
                       :IsAnalysis="-1"
                       v-else-if="questionInfo.QuestionType =='填空题'"
                       :data="questionInfo" />
      <short-answer :IsTitle="false"
                    :IsSelects="false"
                    :IsAnswers="-1"
                    :IsAnalysis="-1"
                    v-else-if="questionInfo.QuestionType =='简答题'"
                    :data="questionInfo" />
      <SynthesisInfo :IsSelects="-1"
                     :data="questionInfo"
                     :childQuestionList="childQuestionList"
                     v-else-if="questionInfo.QuestionType =='综合题'"></SynthesisInfo>
    </el-dialog>
    <!--导入-->
    <el-dialog :before-close="cancel"
               title="Excel导入"
               :visible.sync="ImportDialogVisible"
               width="50%"
               top="3%"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <p class="excelparaph">注意事项：</p>
      <ul class="attention_excel">
        <li>1.导入excel前建议先查看下载模板中的示例，在空白sheet填写导入信息</li>
        <li>2.请按照模板规范顺序导入数据</li>
        <li>3.标红列为必填项</li>
      </ul>
      <el-form ref="form"
               label-width="80px"
               size="mini"
               @submit.prevent="importFile">
        <el-upload class="upload-demo"
                   ref="upload"
                   :data="{courseId}"
                   :action="uploadUrl"
                   :file-list="fileList"
                   :auto-upload="false"
                   :on-success="onSuccess"
                   accept="xls"
                   :limit="1"
                   style="display: inline-block; margin: 0 44px;">
          <el-button slot="trigger"
                     size="small"
                     type="primary">选取文件</el-button>
          <div slot="tip"
               class="el-upload__tip"></div>
        </el-upload>

        <a style="color: #049cdb; text-decoration: underline;"
           href="/public/docs/题库导入模板.xls">下载模板</a>

        <el-table :data="errorList"
                  v-show="errorList.length > 0"
                  style="width: 100%">
          <el-table-column prop="row"
                           label="行号"
                           width="180"></el-table-column>
          <el-table-column prop="error"
                           label="错误"
                           style="width:80%"></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary"
                   @click="importFile()">确 定</el-button>
      </div>
    </el-dialog>
    <!--导入学校题目-->
    <el-dialog type="text"
               width="80%"
               height="100%"
               title="导入题目"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="ImportQueDialogVisible"
               v-if="ImportQueDialogVisible"
               class="question-import-line">
      <ManagerShare :ids.sync="ids"
                    :impCourseId.sync="impCourseId"
                    :type="1"
                    v-if="ImportQueDialogVisible"></ManagerShare>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="ImportQueDialogVisible = false">取消</el-button>
        <el-button type="primary"
                   @click="importQuestion">选择</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Choice from "components/ObjectiveTest/Choice.vue";
import FillInTheBlanks from "components/ObjectiveTest/FillInTheBlanks.vue";
import Multiselect from "components/ObjectiveTest/Multiselect.vue";
import TrueFalse from "components/ObjectiveTest/TrueFalse.vue";
import SynthesisInfo from "components/ObjectiveTest/SynthesisInfo.vue";

import ShortAnswer from "components/SubjectiveTest/ShortAnswer.vue";
import { Message } from "element-ui";
import ManagerShare from "components/ManagerShare.vue";
import QuestionList from "components/Homework_bank/ImportQuestionList.vue";
import {
  GetKnowledgeList,
  AddKnowledge,
  ReviseKnowledge,
  DeleteKnowledge
} from "api/v1.design.questionknowledge.ts";
import {
  GetQuestionList,
  DelQuestion,
  SaveQuestion,
  EditQuestion,
  GetCombineQuestionInfo,
  EditPaperQuestionFiles
} from "api/v1.desgin.question.ts";
import { ImportQuestion } from "api/v1.design.paper.import.ts";
export default {
  name: "QuestionWarehouse",
  components: {
    Choice,
    TrueFalse,
    ShortAnswer,
    Multiselect,
    FillInTheBlanks,
    SynthesisInfo,
    QuestionList,
    ManagerShare
  },
  props: {
    courseId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      newCourseId: this.$route.params.courseId,
      totalCount: 0,
      notsetCount: 0,
      addShow: true,
      inShow: false,
      form: {
        queType: [
          {
            value: 1,
            label: "单选题"
          },
          {
            value: 2,
            label: "多选题"
          },
          {
            value: 3,
            label: "判断题"
          },
          {
            value: 4,
            label: "填空题"
          },
          {
            value: 5,
            label: "简答题"
          },
          {
            value: 6,
            label: "综合题"
          }
        ],
        diffType: [
          {
            value: "1",
            label: "简单"
          },
          {
            value: "2",
            label: "一般"
          },
          {
            value: "3",
            label: "困难"
          }
        ]
      },
      keyvalue: "",
      queTypevalue: "",
      diffTypeValue: "",
      active: "",
      queMainName: "",
      testQueWarehouseCopy: [],
      // showChoice: true,
      showTestName: true,
      inTestName: false,
      centerDialogVisible: false,
      queDetailDialogVisible: false,
      ImportQueDialogVisible: false,
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      knowledgeLists: [],
      questionLists: [],
      type: ["", "单选题", "多选题", "判断题", "填空题", "简答题", "综合题"],
      difficult: ["", "简单", "一般", "困难"],
      selects: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      questionListDetail: [],
      checkContent: "",
      checkType: "",
      checkDiffcult: "",
      knowledgeId: "",
      knowledge: "",
      knowledgeName: "",
      knowledgeNew: "",
      queRadioCon: [],
      diffcultyType: [],
      page: 1,
      valueEditor: "",
      editorQueData: null,
      questionCorrectAnswer: "",
      // 详情
      questionInfo: {
        Difficulty: "",
        QuestionType: "",
        ContentText: "",
        Selects: Array,
        Answers: Array,
        Analysis: "",
        stemFiles: Array,
        analysisFiles: Array
      },
      childQuestionList: [],
      menuShow: false,
      /* ---------------导入数据---------------- */
      ImportDialogVisible: false,
      uploadUrl: "/api/design/QuestionTry/uploadExcel",
      fileList: [],
      errorList: [],
      /* -------------------------------------- */
      isNotset: "",
      myid: "",
      otherid: "",
      loadingShow: false,
      noDataShow: false,
      // 题干附件
      stemFiles: [],
      // 解析附件
      analysisFile: [],
      // 导入题目ID
      ids: [],
      //课程所有题目
      allQuestionList: [],
      impCourseId:''
    };
  },
  created() {
    this.getKnowledgeList();
  },
  methods: {
    backtoclass() {
      this.$router.push({
        name: "ClassNew",
        params: {
          courseId: this.courseId
        }
      });
    },
    lessonAfter(command) {
      switch (command) {
        case "source":
          this.$router.push({
            name: "Courseware",
            params: { courseId: this.newCourseId, folderId: "0" }
          });
          break;
        case "questions":
          this.$router.push({
            name: "QuestionWarehouse",
            params: {
              courseId: this.newCourseId
            }
          });
          break;
        case "teachers":
          this.$router.push({
            name: "CourseTeacherList",
            params: {
              courseId: this.newCourseId
            }
          });
          break;
        case "works":
          this.$router.push({
            name: "Paper",
            params: {
              courseId: this.newCourseId
            }
          });
          break;
        case "activity":
          this.$router.push({
            name: "BrainstormingCourse",
            params: {
              courseId: this.newCourseId
            }
          });
          break;
      }
    },
    // 获取知识点
    getKnowledgeList: function() {
      this.questionListDetail = [];
      GetKnowledgeList(this.courseId).then(rst => {
        if (rst) {
          this.knowledgeLists = rst.knowledgeList;
          this.totalCount = rst.totalCount;
          this.notsetCount = rst.notsetCount;
          if (this.knowledgeId === "") {
            this.active = this.courseId;
            this.queMainName = "";
          }
          this.getQuestionList();
        }
      });
    },
    // 获取题库
    getQuestionList: function(page, isAdd) {
      // this.showChoice = isAdd;
      this.questionListDetail = [];
      this.loadingShow = true;
      GetQuestionList(
        this.courseId,
        this.knowledgeId,
        // this.kmowledgeName,
        this.checkContent,
        this.checkType,
        this.checkDiffcult,
        page,
        this.isNotset,
        this.pageSize
      ).then(rst => {
        this.total = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
        rst.list.forEach(element => {
          element.questionType = this.type[element.questionType];
          element.difficulty = this.difficult[element.difficulty];
        });
        this.questionLists = rst.list;
        this.loadingShow = false;
        if (this.questionLists.length === 0) {
          this.noDataShow = true;
        } else {
          this.noDataShow = false;
        }
        this.myid = rst.myid;
        this.otherid = rst.otherid;
      });
    },
    // 刷新知识点
    RefreshKnowledge: function() {
      this.questionListDetail = [];
      GetKnowledgeList(this.courseId).then(rst => {
        if (rst) {
          this.knowledgeLists = rst.knowledgeList;
          this.totalCount = rst.totalCount;
          this.notsetCount = rst.notsetCount;
        }
      });
    },
    // 切换知识点
    onKnowledgeChangeHandler: function(id, name) {
      this.active = id;
      this.queMainName = name;
      this.valueEditor = id;
      this.knowledgeId = id;
      this.isNotset = "";
      this.knowledgeNew = this.queMainName;
      this.showTestName = true;
      this.inTestName = false;
      this.stemFiles = [];
      this.analysisFile = [];
      this.getQuestionList(1);
    },
    onAllQuesionChangeHandler: function(id, type) {
      if (!type) {
        this.active = this.courseId;
        this.knowledgeId = "";
        this.queMainName = "";
        this.valueEditor = "";
        this.isNotset = "";
        this.getQuestionList(1);
      } else {
        this.active = "NotSet";
        this.knowledgeId = "";
        this.queMainName = "";
        this.valueEditor = "";
        this.isNotset = "notset";
        this.getQuestionList(1);
      }
    },
    // 删除题目
    deleteKnowledge() {
      this.$confirm("此操作将删除该知识点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          DeleteKnowledge(this.knowledgeId, this.courseId).then(rst => {
            if (rst.code === 1) {
              this.knowledgeId = "";
              this.active = "NotSet";
              this.queMainName = "";
              this.RefreshKnowledge();
              this.getQuestionList(1);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 新增知识点-回车
    newKnowledge: function() {
      if (this.knowledge === "") {
        this.addShow = true;
        this.inShow = false;
        this.knowledge = "";
        return false;
      }
      this.inShow = false;
      this.addShow = true;
    },
    // 新增知识点
    addKnowledge() {
      AddKnowledge(this.courseId, this.knowledge).then(rst => {
        if (rst.code === 1) {
          this.knowledge = "";
          this.RefreshKnowledge();
        }
      });
    },
    // 新增知识点-光标移除
    addNewKnowledge: function() {
      if (this.knowledge.trim() === "") {
        this.knowledge = "";
      } else {
        this.addKnowledge();
      }
      this.inShow = false;
      this.addShow = true;
    },
    // 重命名知识点
    updateKnowledge: function() {
      this.knowledgeNew = this.queMainName;
      this.showTestName = false;
      this.inTestName = true;
    },
    // 重命名知识点
    enterUpdateName: function() {
      if (this.knowledgeNew.trim() === "") {
        this.knowledgeNew = "";
      }
      this.showTestName = true;
      this.inTestName = false;
    },
    // 重命名知识点
    hideInput: function() {
      if (this.knowledgeNew.trim() === "") {
        this.knowledgeNew = "";
      } else {
        ReviseKnowledge(this.knowledgeId, this.knowledgeNew).then(rst => {
          GetKnowledgeList(this.courseId).then(rst => {
            this.knowledgeLists = rst.knowledgeList;
            // let knowListArr = rst.knowledgeList;
            this.active = this.knowledgeId;
            this.queMainName = this.knowledgeNew;
            this.knowledgeNew = "";
          });
        });
      }
      this.showTestName = true;
      this.inTestName = false;
    },
    // 搜索题目
    search() {
      this.getQuestionList(1);
    },
    // 查看详情
    setQuestionInfo: function(question) {
      this.questionInfo.Difficulty = question.difficulty;
      this.questionInfo.QuestionType = question.questionType;
      this.questionInfo.ContentText = question.contentText;
      this.questionInfo.Selects = question.selectContent;
      this.questionInfo.Answers = question.answerContent;
      this.questionInfo.Analysis = question.analysis;
      this.questionInfo.Content = question.content;
      // this.questionInfo.stemFiles = question.stemFiles;
      // this.questionInfo.analysisFile = question.analysisFile;
      EditQuestion(question.questionId).then(rst => {
        if (rst.code > 0) {
          this.questionInfo.stemFiles = rst.stemFiles;
          this.questionInfo.analysisFiles = rst.analysisFile;
          this.queDetailDialogVisible = true;
        } else {
          this.$message.warning(rst.msg);
        }
      });
      // this.queDetailDialogVisible = true;
      if (question.questionType === "综合题") {
        GetCombineQuestionInfo(question.questionId).then(rst => {
          if (rst.code > 0) {
            this.childQuestionList = rst.subQuestionList;
          } else {
            this.$message.warning(rst.msg);
          }
        });
      }
    },
    // 添加题目
    addQuestion: function() {
      // this.showChoice = true;
      debugger;
      this.$router.push({
        name: "teaQuestionWarehouseAdd",
        params: {
          courseId: this.courseId,
          knowledgeInfoId: this.active
        }
      });
      this.childQuestionList = [];
      this.stemFiles = [];
      this.analysisFile = [];
    },
    addQueToKnowList: function(ele) {
      this.valueEditor = ele;
    },
    // 保存数据修改
    savaQuestionInfo: function(val) {
      SaveQuestion(
        this.courseId,
        this.valueEditor,
        val.quesType,
        val.diffcult,
        val.content,
        val.correctAnswers,
        val.analysis,
        val.fileIds,
        val.analysisFileIds,
        val.selects,
        val.questionId
      ).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
          // this.showChoice = false;
          this.RefreshKnowledge();
          if (this.active === "NotSet") {
            this.knowledgeId = "";
            this.getQuestionList(this.pageIndex, val.isAdd);
          } else {
            this.getQuestionList(this.pageIndex, val.isAdd);
          }
          this.$refs.Choice.cleanData();
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },

    // 修改保存题目附件
    editPaperQuestionFiles: function(questionId, type, fileIds) {
      EditPaperQuestionFiles(questionId, type, fileIds).then(rst => {
        if (rst.code === 1) {
          this.$message.success(rst.msg);
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },

    // 导入题目
    importQuestion() {
      if (this.active == "NotSet" || this.active == this.courseId) {
        var knowId = "";
      } else {
        var knowId = this.active;
      }
      this.$http
        .post("/api/design/paper/importQuestion", {
          ids: this.ids,
          courseId:  this.courseId,
          knowledgeId: knowId,
          impCourseId: this.impCourseId
        })
        .then(rst => {
          if (rst.code === 1) {
          this.ImportQueDialogVisible = false;
          this.getKnowledgeList();
          this.getQuestionList();
          this.$message.success(rst.msg);
        } else {
          this.$message.error(rst.msg);
        }
        });
      // ImportQuestion(this.ids, this.courseId, knowId,this.impCourseId).then(rst => {
      //   if (rst.code === 1) {
      //     this.ImportQueDialogVisible = false;
      //     this.getKnowledgeList();
      //     this.getQuestionList();
      //     this.$message.success(rst.msg);
      //   } else {
      //     this.$message.error(rst.msg);
      //   }
      // });
    },

    //导出excel提示
    exportTips: function() {
      var that = this;
      GetQuestionList(
        this.courseId,
        this.knowledgeId,
        // this.knowledgeName,
        this.checkContent,
        this.checkType,
        this.checkDiffcult,
        1,
        this.isNotset,
        this.pageSize,
        false,
        true
      ).then(rst => {
        if (rst.code > 0) {
          var that = this;
          var istrue = false;
          var list2 = rst.list;
          that.allQuestionList = rst.list;

          //遍历数组查找综合题
          for (let i = 0; i < list2.length; i++) {
            if (list2[i].questionType == 6) {
              istrue = true;
              break;
            } else {
              istrue = false;
            }
          }

          if (istrue) {
            this.$confirm("综合题暂不能导出, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                that.export2Excel();
                Message.success("导出成功");
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消"
                });
              });
          } else {
            that.export2Excel();
          }
        }
      });
    },

    queDeleteList: function(id) {
      this.$confirm("此操作将删除该题目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          DelQuestion(id).then(rst => {
            if (rst.code === 1) {
              Message.success("删除成功");
              this.getQuestionList(this.pageIndex);
              this.RefreshKnowledge();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    onPageChangeHandler(page) {
      this.getQuestionList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getKnowledgeList(1);
    },
    // parentCloseListen: function(val) {
    //   this.showChoice = false;
    // },
    sureDeleteTest: function() {
      this.centerDialogVisible = false;
    },
    addGroup: function() {
      this.addShow = false;
      this.inShow = true;
      this.$nextTick(() => {
        this.$refs.newKnowledgeInput.$el.querySelector("input").focus();
      });
    },
    // 编辑页面
    queEditor: function(Id, questionType) {
      this.$router.push({
        name: "teaQuestionWarehouseedit",
        params: {
          courseId: this.courseId,
          questionId: Id,
          showButton: "true"
        }
      });
      // if (questionType !== '综合题') {
      //   EditQuestion(Id).then(rst => {
      //     if (rst.code > 0) {
      //       this.valueEditor = rst.question.KnowledgeId;
      //       // this.showChoice = true;
      //       this.editorQueData = rst.question;
      //       this.childQuestionList = [];
      //       this.stemFiles = rst.stemFiles;
      //       this.analysisFile = rst.analysisFile;
      //     } else {
      //       this.$message.warning(rst.msg);
      //     }
      //   });
      // } else {
      //   GetCombineQuestionInfo(Id).then(rst => {
      //     if (rst.code > 0) {
      //       this.valueEditor = rst.question.KnowledgeId;
      //       // this.showChoice = true;
      //       this.editorQueData = rst.question;
      //       this.childQuestionList = rst.subQuestionList;
      //       this.stemFiles = rst.stemFiles;
      //     } else {
      //       this.$message.warning(rst.msg);
      //     }
      //   });
      // }
    },
    // 关闭编辑
    // closeEditorDialog: function() {
    //   this.$refs.Choice.cleanData();
    //   this.editorQueData = null;
    //   this.showChoice = false;
    // },
    changeMenu: function() {
      this.menuShow = !this.menuShow;
    },
    // Excel导入
    cancel() {
      this.ImportDialogVisible = false;
      this.dialogVisible = false;
      this.fileList = [];
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    importFile() {
      this.$refs.upload.submit();
    },
    onSuccess(res) {
      if (res.code < 0) {
        if (res.code === -5) {
          this.errorList = res.list;
        } else {
          this.$message.warning(res.msg);
        }
      } else {
        this.$message.success("导入成功");
        this.ImportDialogVisible = false;
        this.fileList = [];
        this.getKnowledgeList();
      }
    },
    // refresh: function(val) {
    //   this.getQuestionList(this.pageIndex, val.isAdd);
    // }

    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../../vendor/Export2Excel");
        const tHeader = ["知识点","题干", "题型", "难易度", "答案", "解析"];
        const list1 = this.allQuestionList;

        var list = []; //存所有题目
        let maxSelectLength = 0;
        list1.forEach(ele => {
          let info = [];
          info.push(ele.kmowledgeName);
          info.push(ele.contentText);
          info.push(that.type[ele.questionType]);
          info.push(that.difficult[ele.difficulty]);
          if (ele.questionType == 1 || ele.questionType == 2) {
            let answer = "";
            ele.answerContent.forEach(item => {
              // info.push(item);
              answer +=
                item >= 0 && item < this.selects.length
                  ? this.selects[item]
                  : "";
            });
            info.push(answer);

          }
          else if (ele.questionType == 3) {
            if (ele.answerContent == "0") {
              ele.answerContextText = "对";
            } else {
              ele.answerContextText = "错";
            }
            info.push(ele.answerContextText);
          }
          else {
            info.push(ele.answerContextText);
          }
          // info.push(ele.answerContextText);
          info.push(ele.analysisText);

          if (ele.questionType == 1 || ele.questionType == 2) {
            ele.selectContentText.forEach(item => {
              info.push(item);
            });
          }
          maxSelectLength =
            ele.selectContentText.length > maxSelectLength
              ? ele.selectContentText.length
              : maxSelectLength;
          if (ele.questionType != 6) {
            list.push(info);
          }
        });
        for (let i = 0; i < maxSelectLength; i++) {
          tHeader.push("选项" + this.selects[i]);
        }

        export_json_to_excel(tHeader, list, "题库");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style lang="scss">
  .yk-qw-content {
    padding: 0 20px 0 0;
    .yk-come-back-btn-wrapper {
      position: fixed;
      right: 53px;
      top: 10px;
      z-index: 2000;
      .yk-btn-new-back-s {
        padding: 2px 10px;
        .wl-icon-fanhui2 {
          font-size: 29px;
        }
      }
    }

    .yk-sourse-nemu-btn-wrapper-s {
      float: right;
      margin-left: 10px;
      margin-top: 5px;
      width: 90px;
      height: 32px;
      background: #3fa2ff;
      border-radius: 3px;
      line-height: 32px;
      text-align: center;
      color: #000;
      .el-dropdown-link {
        font-size: 11px;
      }
    }
    .yk-source-menus {
      position: fixed;
      bottom: 40px;
      right: 40px;
      margin-top: -120px;
      z-index: 1060;
      width: 100px;
      text-align: center;
      a {
        display: block;
        height: 60px;
        text-align: center;
        border-bottom: 1px solid white;
        background-color: #409eff;
        line-height: 60px;
        text-decoration: none;
        color: white;
        font-size: 16px;
      }
      .fa-plus-circle {
        display: block;
        margin-top: 10px;
        color: #409eff;
        font-size: 50px;
        font-weight: bolder;
        cursor: pointer;
      }
      .menuFade-enter-active,
      .menuFade-leave-active {
        transition: all 0.2s;
      }
      .menuFade-enter,
      .menuFade-leave-to {
        transition: all 0.2s;
        transform: translateX(100%);
      }
      .linkActive {
        color: white;
        background-color: #19a580;
      }
    }
    .el-form-change-search .el-input--suffix .el-input__inner{
      background-color:#fff;
    }
    .tea-quesiton-ware-content .tea-question-main-wrapper .yk-main-head .yk-que-config .el-form .el-form-item .el-form-item__label{
      color:#000;
    }
  }
  .tea-quesiton-ware-content {
    .tea-question-side-wrapper {
      float: left;
      .yk-el-aside {
        .yk-el-aside-title {
          color: #000;
          height: 50px;
          // border: 1px solid #000;  
          line-height: 50px;
          font-size: 18px;
          padding-left: 19px;
          border-bottom:1px solid #E1E9F0;
          span{
            // font-weight: bold;
            margin-left:5px;
          }
        }
        .yk-qu-con-header,
        .yk-qu-con-footer {
          position:relative;
          display: flex;
          // justify-content: space-between;
          // padding: 13px 15px;
          height: 50px;
          line-height: 50px;
          // border-bottom: 1px solid #f5f5f5;
          // vertical-align: center;
          color: #000;
          cursor: pointer;       
          position: relative;
          // span,
          // .yk-title {
          //   display: inline-block;
          // }
          .yk-title {
            font-size: 16px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            width: 175px;
            // margin-left:36px;
          }
          &:hover {
            // background-color: #DDE4EB;
            // border-left:3px solid #409EFF;
            .line-active{
              display: block;
            }
          }
          .wl-icon-xiaoyuan{
            font-size:36px;
            // position: absolute;
            // top: 0;
            // left: 0;
          }
          span{
            float: right;
            height: 18px;
            background: #409EFF;
            color:#fff;
            line-height: 14px;
            margin-top: 18px;
            padding: 0 5px;
            border-radius: 9px;
          }
          .el-checkbox__input{
            display: none;
          }
        }
        .yk-qu-con{
          position:relative;
          display: flex;
          height: 50px;
          line-height: 50px;
          // border-bottom: 1px solid #f5f5f5;
          color: #000;
          cursor: pointer;       
          .yk-title {
            font-size: 16px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            width: 158px;
          }
          &:hover {
            // background-color: #DDE4EB;
            // border-left:3px solid #409EFF;
            .line-active{
              display: block;
            }
          }
          .wl-icon-xiaoyuan{
            font-size:36px;
          }
          .sp-question-count{
            float: right;
            height: 18px;
            border:1px solid #409EFF;
            color:#409EFF;
            line-height: 14px;
            margin-top: 18px;
            padding: 0px 5px;
            border-radius: 9px;
          }
          .point-span{
            display: inline-block;
            width: 8px;
            height: 8px;
            border: 1px solid #333333;
            border-radius: 50%;
            margin: 20px 10px 0 34px;
          }
          .el-checkbox{
            position: absolute;
            left: 5px;
            .el-checkbox__inner{
                // background: #374256;
              }
          }
          span{
              float: right;
              height: 18px;
              border: 1px solid #409eff;
              color: #409eff;
              line-height: 17px;
              margin-top: 18px;
              padding: 0 5px;
              border-radius: 9px;
          }
        }
        .active {
          background-color: #DDE4EB;
          // border-left:3px solid #409EFF;
          .line-active{
            display: block;
          }
        }
        .line-active{
          background-color: #409EFF;
          position: absolute;
          height:100%;
          width:3px;
          top: 0px;
          left: -1px;
          display: none;
          // span{
          //   position: absolute;
          //   height: 100%;
          //   position: absolute;
          //   height: 100%;
          //   width: 100%;
          //   top: -14px;
          //   left: 2px;
          //   background: #DDE4EB;
          // }
        }
        .yk-add-group {
          margin-top: 20px;
          margin-bottom: 10px;
          text-align: center;
          cursor: pointer;
          font-size: 17px;
          color: #009688;
          i {
            font-weight: bolder;
            color: #409eff;
          }
        }
      }
    }
    .tea-question-main-wrapper {
      float: right;
      padding-left: 20px;
      padding-top: 20px;
      width: calc(100% - 261px);
      border-left: 1px solid #ccc;
      background: #fff;
      box-sizing: border-box;
      .yk-main-head {
        border-bottom: 1px solid rgba(225,233,240,1);
        .yk-que-name {
          display: flex;
          float: left;
          font-size: 20px;
          margin-top: 7px;
          .yk-update-que-name-wrapper {
            padding-top: 10px;
            color: #000;
            .que-main-name {
              float: left;
              max-width: 225px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #000;
              margin-top: -7px;
            }
            .yk-update-que-name-operate {
              float: left;
            }
          }
          .el-dropdown {
            .el-dropdown-link {
              color: white;
              font-size: 20px;
            }
          }
          .test-name {
            margin-right: 10px;
          }
          i:hover {
            cursor: pointer;
          }
          i {
            margin-left: 10px;
            color: #409EFF;
          }
          span p {
            font-size: 20px;
          }
        }
        .yk-que-config {
          float: right;
          .el-form {
            float: left;
            .el-form-item {
              .el-form-item__label {
                color: #000;
              }
            }
          }
          .el-input__inner{
            border: 1px solid rgba(230,230,230,1);
            width:160px;
          }
          .el-icon-search{
            font-size: 18px;
          }
        }
        .yk-que-config:after {
          content: '';
          clear: both;
          height: 0;
          visibility: hidden;
          display: block;
        }
        &:after {
          display: block;
          height: 0px;
          content: '';
          clear: both;
        }
      }
      .yk-main-que-content {
        padding-bottom: 5px;
        color: #333;
        margin-top: 40px;
        min-height: 600px;
        .yk-que-con:first-child {
          margin-top: 0px;
        }
        .yk-que-con {
          margin-top: 20px;
          padding-bottom: 20px;
          // border-bottom: 1px solid #d7d7d7;
          .yk-que-head {
            height: 50px;
            line-height: 50px;
            background-color: #DDE4EB;
            border-radius:6px 6px 0px 0px;  
            padding-left: 20px;
            .que-index{
              font-weight: bold;
              margin-right: 10px ;
            }
            .yk-que-head-info {
              float: left;
              font-size: 18px;
              .que-type,
              .diff-type {
                margin-right: 25px;
                .span-spacing{
                  margin-right: 5px;
                }
              }
            }
            .yk-que-head-operate {
              float: right;
              margin-right: 20px;
              // color:#DDE4EB;
              cursor:pointer;
              .el-icon-more {
                margin: 0 20px;
                font-size: 17px;
                transform: rotate(90deg);
                -ms-transform: rotate(90deg);
                -moz-transform: rotate(90deg);
                -webkit-transform: rotate(90deg);
                -o-transform: rotate(90deg);
              }
              .el-dropdown-link {
                display: block;
                outline: none;
              }
              i{
                margin-right:3px;
              }
            }
            &:after {
              display: block;
              height: 0;
              content: '';
              clear: both;
            }
          }
          .yk-que-opotion {
            margin-top: 10px;
            ul {
              list-style: none;
              li {
                margin-top: 10px;
                span:first-child {
                  margin-right: 10px;
                  font-weight: bolder;
                }
              }
            }
          }
          .yk-que-name{
            width: 100%;
            // margin-top: -14px;
            background: #F7F7F7;
            padding: 20px 25px;
            box-sizing: border-box;
          }
        }
        .que-li{
          width: calc( 100% - 60px );
          p{
            margin-top: 0px;
            margin-left: 5px;
          }
        }
      }
      .add-question-new-wrapper-s {
        width: 100%;
        margin-top: 15px;
        .add-question-new-wrapper-child-1 {
          float: left;
          width: 30%;
          text-align: center;
          border: 1px dashed #000;
          height: 50px;
          line-height: 50px;
          color: #000;
          font-size: 17px;
          border-radius: 10px;
        }
        .add-question-new-wrapper-child-2 {
          float: right;
          width: 29%;
          margin-left: 5%;
          text-align: center;
          border: 1px dashed #000;
          height: 50px;
          line-height: 50px;
          color: #000;
          font-size: 17px;
          border-radius: 10px;
        }
        .wl-icon-tianjia {
          margin-right: 10px;
          font-size: 30px;
          border: 2px solid #000;
          border-radius: 50%;
          vertical-align: -5px;
        }
        .wl-icon-daoru1 {
          margin-right: 10px;
          font-size: 30px;
          vertical-align: -5px;
        }
      }
      .el-pagination {
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .yk-que-detail {
      .yk-que-choice {
        ul {
          list-style: none;
          li {
            span:first-child {
              font-weight: bolder;
            }
            span:last-child {
              margin-left: 10px;
              color: gray;
            }
          }
        }
      }
      .yk-que-type {
        padding: 10px 0;
        span:last-child {
          margin-left: 10px;
        }
      }
      .yk-que-head {
        font-weight: bolder;
      }
    }
    .el-pagination__total{
      margin-right: 10px;
      font-weight: 400;
      color: #000;
    }
    .el-pagination__jump{
      margin-left: 24px;
      font-weight: 400;
      color: #000;
    }
  }
  .yk-dialogCon-new-s {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.4);
    .yk-choiceCon {
      padding: 0 0 20px;
      position: absolute;
      // overflow: auto;
      left: 50%;
      top: 50px;
      margin-left: -370px;
      width: 760px;
      padding: 10px;
      border-radius: 10px;
      // height: 500px;
      background-color: white;
      .yk-add-group {
        position: absolute;
        padding: 5px 0;
        width: 740px;
        left: 50%;
        margin-left: -370px;
        z-index: 1000;
        // background-color: #409eff;
        .knowledge {
          margin-left:20px;
          margin-right:13px;
          // color: white;
          font-size: 16px;
        }
        .el-icon-close {
          position: absolute;
          top: 10px;
          right: 10px;
          // color: white;
          font-size: 25px;
          font-weight: bolder;
          cursor: pointer;
        }
        .el-select__caret{
          line-height:32px;
        }
      }
    }

    &.slide-enter-active,
    &.slide-leave-active {
      transition: all 0.4s;
      background-color: rgba(0, 0, 0, 0);
    }
    .yk-choice-main {
      margin-top: 60px;
    }
  }
  .yk-qw-content-new {
    .el-input__inner {
      height: 32px;
    }
    .el-form-item-que-type {
      .el-input__inner {
        width: 113px;
      }
    }
    .el-form-item-search-que-name {
      .el-input__inner {
        width: 140px;
      }
    }
    // .yk-update-que-name-wrapper {
    //   padding-top: 10px;
    //   color: #000;
    //   .que-main-name {
    //     float: left;
    //     max-width: 140px;
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     white-space: nowrap;
    //   }
    //   .yk-update-que-name-operate {
    //     float: left;
    //   }
    // }
    .tea-quesiton-ware-content{
      background: #F7F7F7;
      .tea-question-main-wrapper .yk-main-que-content{
        color:#000;
      }
    }
  }
  .left{
    float: left;
  }
  .right{
    float:right;
  }

  
</style>
